/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const problemInNumbersRowDtoSchema = z.object({
  metric: z.optional(z.string()),
  value: z.optional(z.string()),
  interpretation: z.optional(z.string()),
});
